import urSnackbar from "./urSnackbar.vue";
import urGlobalSnackbar from "./urGlobalSnackbar";
import snacbkarEvent from "./snackbarEvents";
export default {
    install(Vue){
        Vue.component(urSnackbar.name, urSnackbar);

        if (this.installed) {
            return
        }

        this.installed = true;

        const showSnackbar = (params) => {
            if (typeof params === 'string') {
                params = { title: '', text: params }
            }

            if (typeof params === 'object') {
                snacbkarEvent.$emit('show-snackbar', params);
            }
        };
        const addSnackbar = (params) => {
            if (typeof params === 'string') {
                params = { title: '', text: params }
            }

            if (typeof params === 'object') {
                snacbkarEvent.$emit('add-snackbar', params);
            }
        };
        Vue.prototype.$showSnackbar = showSnackbar;
        Vue.prototype.$addSnackbar = addSnackbar;
    }
};
